import { connect } from 'react-redux';
import UserForm from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
